<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 mt-4" style="position: relative">
      <div style="display: flex; align-items: center">
        <span
          ><v-btn
            icon
            color="primary"
            to="/weserve_admin_login/-/reportdashboard/main"
            class="pa-4"
          >
            <v-icon color="black">arrow_back</v-icon></v-btn
          ></span
        >
        <span class="main-title">MAIN DASHBOARD | &nbsp;</span>
        <span class="submain-title">User Connect Wallet</span>
      </div>
      <div style="display:flex;">
        <v-text-field
          class="pr-4"
          hide-details
          prepend-icon="search"
          v-model="search"
          placeholder="name, wallet adddress, device, serial number/UUID, wallet provider "
        ></v-text-field>

        <div
          style="display: flex; justify-content: flex-end"
          v-if="search == ''"
        >
          <download-excel
            :data="user_connect_wallet_report"
            :fields="{
              No: 'no',
              'USER ID': 'wallet_device.device_user.user_id',
              'First name': 'wallet_device.device_user.user_first_name',
              'Last name': 'wallet_device.device_user.user_last_name',
              Device: 'wallet_device.device_model',
              'Serial number/UUID': 'wallet_device.device_serial_number',
              'Wallet Address': 'wallet_address',
              'Wallet Provider': 'wallet_provider',
              'First Connected': 'create_at',
              'Last Connected': 'update_at',
            }"
            :name="`UserConnectWallet_${moment().format('YYYY-MM-DD')}.xls`"
            style="margin-right: 50px"
          >
            <v-btn icon> <v-icon large color="black">print</v-icon>.xls </v-btn>
          </download-excel>

          <download-excel
            type="csv"
            :data="user_connect_wallet_report"
            :fields="{
              No: 'no',
              'USER ID': 'wallet_device.device_user.user_id',
              'First name': 'wallet_device.device_user.user_first_name',
              'Last name': 'wallet_device.device_user.user_last_name',
              Device: 'wallet_device.device_model',
              'Serial number/UUID': 'wallet_device.device_serial_number',
              'Wallet Address': 'wallet_address',
              'Wallet Provider': 'wallet_provider',
              'First Connected': 'create_at',
              'Last Connected': 'update_at',
            }"
            :name="`UserConnectWallet_${moment().format('YYYY-MM-DD')}.csv`"
          >
            <v-btn icon> <v-icon large color="black">print</v-icon>.csv </v-btn>
          </download-excel>
        </div>
      </div>
    </div>

    <userConnectWalletTable
      :items="user_connect_wallet_report"
      :loading="searching"
      :search="search"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import userConnectWalletTable from "@/components/back-office/Report/MainDashboard/UserConnectWalletTable.vue";

export default {
  data() {
    return {
      searching: false,
      search: "",
    };
  },
  components: {
    userConnectWalletTable,
  },
  destroyed() {
    this.$store.commit("report/resetState");
  },
  computed: {
    ...mapState({
      user_connect_wallet_report: (state) =>
        state.report.user_connect_wallet_report,
      search_config: (state) => state.report.clone_config_path,
    }),
  },
  methods: {
    ...mapActions({
      fetchConnectWalletReport: "report/fetchConnectWalletReport",
      fetchRewardReportByDistrict: "report/fetchRewardReportByDistrict",
    }),
    async searchList() {
      this.searching = true;
      await this.fetchConnectWalletReport();
      this.searching = false;
    },
  },

  mounted() {
    this.searchList();
  },

  created() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard",
      },
      {
        text: "Reward report",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
</style>
